export enum ComboVariantEnum {
    Mounted = 'Mounted',
    Unmounted = 'unmounted',
    Both = 'both',
}
